import { connect } from 'react-redux';
import { createMatchSelector } from 'connected-react-router';
import { pipe, prop } from 'ramda';

import MedicalTherapyInfo from 'components/MedicalTherapyInfo';
import {
  getReportItemReviewedDateTime,
  getReportItemMedicalTherapyComments,
  getReportItemMedicalTherapyStatus,
  getReportItemMedicalTherapyStatusText,
  getReportReviewedBy,
} from 'store/selectors/reports/singleItems';
import { getClinicPhone, getClinicName } from 'store/selectors/questionnaireResponses';
import { getUserRole } from 'store/selectors/user';

const mapStateToProps = state => {
  const { observationId, patientId } = pipe(
    createMatchSelector('/patient/:patientId/transmission-report/:observationId'),
    prop('params'),
  )(state);

  return {
    role: getUserRole(state),
    doctorName: getReportReviewedBy(observationId)(state),
    clinicName: getClinicName(patientId)(state),
    clinicPhone: getClinicPhone(patientId)(state),
    comments: getReportItemMedicalTherapyComments(observationId)(state),
    reviewedDateTime: getReportItemReviewedDateTime(observationId)(state),
    status: getReportItemMedicalTherapyStatus(observationId)(state),
    statusText: getReportItemMedicalTherapyStatusText(observationId)(state),
  };
};

export default connect(mapStateToProps)(MedicalTherapyInfo);
